<template>
  <div>
    <br>
    <h1>マイペット</h1>

    <el-form :inline="true" :model="form">
      <br>
      <div v-loading="loading">
        <div v-if="!loading">
          <div v-if="petList.length > 0">
            <table class="commonTable">
              <colgroup>
                <col style="width: 40%;">
                <col style="width: 30%;">
                <col style="width: 30%;">
              </colgroup>
              <tr>
                <th>名前</th>
                <th>飼育ステータス</th>
                <th>承認ステータス</th>
              </tr>
              <tr v-for="item in petList" :key="item.petSeq">
                <td style="text-align: left; word-wrap: break-word; white-space: normal;">
                  <el-link type="primary" @click="goPetRegistOrMyPetHome(item.petSeq, getWfStatusLabel(item.wfStatus))">
                    {{ item.petName }}
                  </el-link>
                </td>
                <td>
                  {{ getShiikuStatusLabel(item.shiikuStatus) }}
                </td>
                <td 
                  :class="{'clickable-status': ['却下','差戻し'].includes(getWfStatusLabel(item.wfStatus))}"
                  @click="onStatusClick(getWfStatusLabel(item.wfStatus), item.petAdmitReason)"
                >
                  {{ getWfStatusLabel(item.wfStatus) }}
                </td>
                <!-- <td>
                  <el-button 
                    v-if="isDeleteButtonVisible(item.shiikuStatus)"
                    native-type="button"
                    type="danger"
                    plain
                    @click="deletePetInfo(item)">削除
                  </el-button>
                </td> -->
              </tr>
            </table>
          </div>
          <div v-else>データがありません</div>
        </div>
        <br>
        <el-button native-type="button" type="danger" @click="goPetRegist();">ペット新規登録申請</el-button>
      </div>
      <br>
      <div v-if="loading"><br><br></div>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import { Message, MessageBox } from 'element-ui';
import { getShiikuStatusLabel, getWfStatusLabel } from '@/utils/constant';

export default {
  name: 'MyPets',
  data() {
    return {
      loading: false,  // ローディング中
      petList: [],     // ペット情報
      rules: {},       // バリデーションルール
      form: {}         // フォーム
    };
  },
  created() {
    this.loading = true;
    // ペット情報取得
    request('getMyPetsInfo', {}).then((res) => {
      this.petList = res?.petList;
    }).finally(() => {
      this.loading = false;
    });  
  },
  methods: {
    // 飼育ステータス名称取得
    getShiikuStatusLabel,
    // 承認ステータス名称取得
    getWfStatusLabel,
    // // 削除ボタン表示判定
    // isDeleteButtonVisible(shiikuStatus) {
    //   return getShiikuStatusLabel(shiikuStatus) === '飼育予定';
    // }
    // ペット情報削除
    deletePetInfo(item) {
      MessageBox.confirm(`${item.petName} を削除すると、アルバムおよびペット体調管理もすべて削除されます。よろしいでしょうか？`, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(() => {
        request('deletePetInfo', item.petSeq).then((res) => {
          this.petList = this.petList.filter(p => p.petSeq !== item.petSeq);
          Message.success(res.msg);
        });  
      });
    },
    // 承認ステータスクリック
    onStatusClick(status, reason) {
      if (['却下', '差戻し'].includes(status)) {
        MessageBox.alert(reason, '理由', {
          confirmButtonText: '閉じる',
          type: 'info',
          customClass: 'wide-message-box'
        });
      }
    },
    goPetRegistOrMyPetHome(petSeq, wfStatus) {
      const path =
        (wfStatus === '一時保存' || wfStatus === '差戻し')
          ? '/petRegist'
          : '/myPetHome';
      this.$router.push({
        path,
        query: { petSeq }
      }).catch(() => {});
    },
    goPetRegist() {
      this.$router.push({
        path: '/petRegist',
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less">
  html, body {
    overflow-x: hidden; // 横スクロールを防止
    width: 100%;        // 幅を100%に設定
  }
  h1 {
    padding-top: 10em;
    padding: 0.25em 0.5em;
    color: #494949;
    background: transparent;
    border-left: solid 5px #7db4e6;
  }
  .commonTable {
    width: 100%;
    table-layout: left;
    border-collapse: collapse;
    border-spacing: 0;
    border: solid 2px #778ca3;
  }
  .commonTable th {
    padding: 10px;
    background: #e9faf9;
    border: solid 1px #778ca3;
    border-bottom: solid 2px #778ca3;
  }
  .commonTable td {
    padding: 4px;
    border-left: solid 1px #778ca3;
    word-wrap: break-word;
  }
  .commonTable tr {
    border-top: dashed 1px #778ca3;
  }
  .clickable-status {
    cursor: pointer;                /* カーソルを指型に変更 */
    color: #409EFF;               /* リンクの色 */
  }
  .clickable-status:hover {
    text-decoration: underline;     /* ホバー時にアンダーバーを表示 */
  }
  @media screen and (max-width: 768px) {
    .commonTable {
      table-layout: fixed;
      width: 100%;
    }
    .commonTable th,
    .commonTable td {
      font-size: 14px;
      padding: 6px 2px;
    }
    /* 第1列は改行を許可 */
    .commonTable td:first-child,
    .commonTable th:first-child {
      white-space: normal !important;
      word-break: break-all;
      width: 34% !important;
      min-width: 80px;
      max-width: 60vw;
    }
    /* 第2、3列のヘッダーと内容は改行せず、超過分を省略 */
    .commonTable th:nth-child(2),
    .commonTable th:nth-child(3),
    .commonTable td:nth-child(2),
    .commonTable td:nth-child(3) {
      white-space: nowrap !important;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 33% !important;
      max-width: 40vw;
    }
  }
  .wide-message-box {
    min-width: 0;
    max-width: 90vw;
    word-break: break-all;
  }
</style>
